module.exports = __webpack_public_path__ + "img/dyamicTwoImg.ff48aafe.png";